export const getSupportedLocale = (): string => {
  const envTest = import.meta.env.NODE_ENV !== 'test';
  const DEFAULT_LOCALE = 'no'; // Norway - Default,

  if (envTest) {
    return DEFAULT_LOCALE;
  }

  // Norway, Chile, Scotland, Australia, USA, Canada, Iceland,
  const language = navigator.language;
  const SUPPORTED_LOCALES = ['no', 'en-GB', 'gd', 'en-AU', 'is', 'fo', 'en-CA', 'es-CL'];

  return SUPPORTED_LOCALES.includes(language) ? language : DEFAULT_LOCALE;
};
